var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider"},_vm._l((_vm.images),function(image,index){return _c('BaseImage',{key:index,staticClass:"slider-item",attrs:{"image":image.url_image}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }